// import

import {styled} from 'goober';
import type {ComponentProps} from 'react';

import type {PostNode} from 'libs/model';
import {Link} from 'modules/Link';
import {Meta, BannerImage} from 'modules/Solo';

// types

type Props = ComponentProps<typeof Styled> & {
  post: PostNode;
};

// component

export function Postlet(props: Props) {
  const {post, ...rest} = props;

  return (
    <Styled {...rest} data-test="post">
      <BannerImage
        className="image"
        height={500}
        node={post}
        width={500}
      />

      <div>
        <h1>
          <Link href={post.meta.link}>{post.meta.title}</Link>
        </h1>
        <Meta className="meta" node={post} />
      </div>
    </Styled>
  );
}

// styles

const Styled = styled('article')`
  display: flex;
  gap: 1.5rem;
  align-items: center;

  .image {
    flex: 0 0 auto;
    width: 6.5rem;
  }

  > div {
    flex: 1 1 auto;
  }

  h1 {
    margin: 0;
    font-weight: 300;
    font-size: 1.5rem;
    line-height: 2rem;
  }

  > div > footer {
    overflow: hidden;
    height: 2rem;
  }

  @media (min-width: 36em) {
    h1 {
      max-height: 4rem;
      overflow: hidden;
    }
  }

  @media (max-width: 35.99875em) {
    align-items: flex-start;
    gap: 0.5rem;

    .image {
      width: 3rem;
    }
  }
`;
